import {Observable} from 'rxjs';
import { AggregatorListValue } from '@portal-workspace/grow-shared-library'


export type AggregatorListValueGetFn = ()=>Observable<Exclude<AggregatorListValue, null>[]>;
